<template>
  <div>
    <el-dialog title="修改密码" :visible.sync="showDialog" width="50%" @close="closeDialog" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form ref="form" :model="form" :rules="rules" size="small" label-position="right" label-width="110px">
        <el-form-item label="旧密码" prop="oldPassword">
          <el-input type="password" v-model="form.oldPassword"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input type="password" v-model="form.newPassword"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirm">
          <el-input type="password" v-model="form.confirm"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="dialog-btn" :loading="loading" type="primary" @click="onSubmit('form')">确认</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { checkPwd } from '@/utils/validate';
export default {
  data() {
    var checkPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入新密码'))
      } else {
        callback()
      }
    }
    var checkConfirm = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请再次确认密码'))
      } else if(value != this.form.newPassword) {
        callback(new Error('两次密码不同，请重新确认'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      showDialog: this.show,
      form: {
        userId: this.Cookies.get('cloud_I'),
        oldPassword: '',
        newPassword: '',
        confirm: ''
      },
      rules: {
        oldPassword: [{ required: true, message: '请输入旧密码', trigger: 'blur' }],
        newPassword: [{ required: true, validator: checkPassword, trigger: 'blur' }],
        confirm: [{ required: true, validator: checkConfirm, trigger: 'blur' }]
      }
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    show: function (value) {
      if(this.$refs['form']) this.$refs['form'].resetFields()
      this.showDialog = value
    }
  },
  methods: {
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.doEdit()
        }
      })
    },
    doEdit() {
      this.loading = true
      this.request({
        url: '/manager/user/repassword',
        method: 'post',
        data: this.form
      }).then(response => {
        this.loading = false
        this.showDialog = false
        this.$message({
          message: '密码修改成功',
          type: 'success',
          duration: 3 * 1000,
        })
      }).catch(error => {
        this.loading = false
        this.$message({
          message: error.errmsg,
          type: 'error',
          duration: 3 * 1000
        })
      })
    },
    closeDialog() {
      this.$emit('receive',{
        key: 'showPwd',
        value: this.showDialog
      })
    },
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/account/EditPassword.vue